import { createAction } from '@reduxjs/toolkit';

export const linkRequested = createAction('creativeHub/googleBulk/linkRequested');

export const setInProgress = createAction<{ hash: string; inProgress: boolean }>(
  'creativeHub/googleBulk/setInProgress',
);

export const setProgressValue = createAction<{ hash: string; value: number }>(
  'creativeHub/googleBulk/setProgressValue',
);

export const linkCreated = createAction<{ hash: string; link: string }>(
  'creativeHub/googleBulk/linkCreated',
);
